import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
  Collapse,
} from '@material-ui/core'
import { mdiChevronUp, mdiChevronDown } from '@mdi/js'

import { alertConfig } from '../../utils/AlertConfig'
import Link from '../controls/Link'
import StatusIcon from '../controls/StatusIcon'
import CommunityUnitNameContainer from '../controls/CommunityUnitNameContainer'

class AlertsView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    alerts: PropTypes.array.isRequired,
    timeseries: PropTypes.object.isRequired,
    alertLink: PropTypes.func,
  }

  static defaultProps = {
    alertLink: null,
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: theme.spacing(1),
      height: '100%',
    }),
    clickable: theme.clickable,
  })

  static collapseAfter = 5

  state = { open: false }

  handleClick = () => {
    this.setState(
      (prevState) => ({
        open: !prevState.open,
      }),
    )
  }

  communityUnitName = (timeseries) => {
    if (timeseries && timeseries.unit_id) {
      return (
        <CommunityUnitNameContainer unitId={timeseries.unit_id} />
      )
    }
    return null
  }

  alertText = (alert) => {
    const ts = this.props.timeseries[alert.timeseries_id]
    const { name } = (ts || { name: alert.timeseries_id })
    const { title } = (ts || { title: name })
    return (
      <>
        {alert.message} in {this.communityUnitName(ts)}
        <Typography variant="caption" display="block">{title}</Typography>
      </>
    )
  }

  alertLink = (alert) => {
    const { alertLink, timeseries } = this.props

    // If function was passed in, call that
    if (alertLink) {
      return alertLink(alert)
    }

    // Else, link to the unit
    const ts = timeseries[alert.timeseries_id]
    let link = ''
    if (ts) {
      link = `/units/${ts.unit_id}`
    }
    return link
  }

  alertHtml = (alert) => (
    <ListItem
      className={this.props.classes.clickable}
      component={Link}
      to={this.alertLink(alert)}
      key={`${alert.timeseries_id}:${alert.type}`}
    >
      <ListItemIcon><StatusIcon status={alertConfig(alert.type).severity.text} /></ListItemIcon>
      <ListItemText primary={this.alertText(alert)} primaryTypographyProps={{ color: 'textPrimary' }} />
    </ListItem>
  )

  alertsHtml = (alerts) => (
    <>
      {alerts.slice(0, AlertsView.collapseAfter).map((alert) => (
        this.alertHtml(alert)
      ))}
      {this.collapseHtml(alerts)}
    </>
  )

  collapseHtml = (alerts) => {
    if (alerts.length > AlertsView.collapseAfter) {
      return (
        <>
          <Collapse component="li" in={this.state.open} timeout="auto" unmountOnExit>
            {alerts.slice(AlertsView.collapseAfter).map((alert) => (
              this.alertHtml(alert)
            ))}
          </Collapse>
          <ListItem button onClick={this.handleClick}>
            <ListItemIcon>
              <SvgIcon>
                <path
                  d={
                    this.state.open
                      ? mdiChevronUp
                      : mdiChevronDown
                  }
                />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText inset primary={this.state.open ? 'Less' : 'More'} />
          </ListItem>
        </>
      )
    }
    return null
  }

  render() {
    const { classes, alerts, timeseries } = this.props
    if (alerts.length > 0 && timeseries) {
      return (
        <Paper className={classes.paper} elevation={0}>
          <Typography variant="h6">Alerts</Typography>
          <List component="nav">
            {this.alertsHtml(alerts)}
          </List>
        </Paper>
      )
    }
    return null
  }
}

export default withStyles(AlertsView.styles)(AlertsView)
